import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsBauhausSkin = {
  ...textEffectsSharedSkin,
  'text-effects-color-1': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-color-2': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-color-3': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'bevel-angle': {
    type: 'CSSString',
    defaultValue: '0deg',
  },
  'shadow-distance': {
    type: 'ALPHA',
    defaultValue: '10',
  },
  'layer-blend-mode': {
    type: 'CSSString',
    defaultValue: 'multiply',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsBauhausSkinDefinitionMap: Record<
  string,
  SiteAssetsSkinParams
> = {
  'wixui.skins.TextEffectsBauhaus': TextEffectsBauhausSkin,
};

export default generateSkinDefaults(TextEffectsBauhausSkinDefinitionMap);
